
import { Typography, Backdrop } from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';





export const BackdropScreen = ({ cargando, titulo }) => {


    return (
        // zIndex:(theme) => theme.zIndex.drawer + 1,
        <Backdrop open={cargando} 
            sx={{ color:'white', display: 'flex', zIndex: 9999, flexDirection:'column', 
            justifyContent:'center', alignItems:'center', backgroundColor:'rgba(0,0,0,0.9)'
        }}>
            
            <CircularProgress color="inherit" />
            
            <Typography sx={{fontSize:23, fontWeight:'bold', mt:2, textAlign:'center'}} >{ titulo }</Typography>
        </Backdrop>

    )
}
